import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Button,
  Grid,
  Header,
  Input,
  Modal,
  Image
} from 'semantic-ui-react';

import {
  changeScreen,
  closeScreens,
} from '../actions/bookPayConfirmActions';

import qrCode from '../images/confirmationScreen/qrCode.svg';

class ConfirmationScreen extends Component {
  render() {
    return (
      <>
        <Modal.Content>
          <Grid container>
            <Grid.Row>
              <Grid.Column width='8'>
                <Grid container>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as='h3' >
                        {'Ihr Parkschein für '}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row style={{ paddingTop: 0 }}>
                    <Grid.Column>
                      <Header as='h2' >
                        {this.props.parkingLotName}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row style={{ paddingTop: 0 }}>
                    <Grid.Column>
                      <Image src={qrCode} />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row >
                    <Grid.Column>
                      <Header as='h3' >
                        Ihre Fahrkarte für den öffentlichen Verkehr
                        </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row style={{ paddingTop: 0 }}>
                    <Grid.Column>
                      <Image src={qrCode} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column width='8'>
                <Grid container>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as='h3'>
                        Parkschein und Fahrkarte an Email weiterleiten:
                      </Header>
                      <Input fluid placeholder='Geben Sie hier Ihre E-Mail Adresse ein' />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as='h3' >
                        Vielen Dank! Wir wünschen eine sichere und angenehme Reise!
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            size='large'
            color='black'
            onClick={() => { this.props.changeScreen(1) }}
            content='Zurück'
          />
          <Button
            size='large'
            color='black'
            onClick={() => { this.props.closeScreens() }}
            content='Bestätigen'
          />
        </Modal.Actions>
      </>
    );
  }
}

export default connect(null, { closeScreens, changeScreen })(ConfirmationScreen)